import { useState } from 'react'
import arrowdown from '@features/projects/assets/arrow-down.svg';
import menupoints from '@features/projects/assets/menupoints.png';
import addcircle from '@features/projects/assets/addcircle.png'
import { AddTask } from '../../Task/AddTask';
import detailProjectStyles from '@projects-styles/detailproject.module.scss';
import { showCreateUpdateSection } from '../../../../../slices/projectsSlice';
import { useDispatch } from 'react-redux';
import { useI18n } from '../../../../../../i18n/useI18n';
import type { ISection } from '../../../../../../../api/projects/types';
import { IFormData } from '@/api/tasks/types';

export interface OptionsSprintProps {
  sectionData: ISection;
  newTask: (form: IFormData) => void;
  activeId: { id: number; active: boolean };
  handleClick: (id: number) => void;
  // handlerUpdateSection: (id: number) => void;
  handleCancel: (id: number, state: boolean) => void;
  // handlerDelete: (id: number) => void;
  handlerShowSection: (sectionId: number) => void;
  isCollapsed?: boolean;
}

export const OptionsSprint = ({
  sectionData,
  newTask,
  activeId,
  handleClick,
  handleCancel,
  handlerShowSection,
  isCollapsed
  // handlerDelete
}: OptionsSprintProps) => {
  const [task, setTask] = useState(false);
  const dispatch = useDispatch();
  const { t } = useI18n();
  const { description, name: title, id: sectionId } = sectionData;

  const addNewTask = (form: IFormData) => {
    if (form.title && form.title.length > 0) {
      newTask(form);
      setTask(!task);
    }
  };

  const closeAddTask = () => {
    setTask(!task);
  }

  return (
    <div className={detailProjectStyles["optionssprint"]}>
      <div className={detailProjectStyles["optionssprint__area"]}>
        <div className={detailProjectStyles["optionssprint__arrowtext"]}>
          <button className={detailProjectStyles["optionssprint__arrow-button"]}
            aria-label={`${isCollapsed ? 'Expand' : 'Collapse'} section`}
            onClick={() => handlerShowSection(sectionId)}
          >
            <img src={arrowdown}
              className={`${detailProjectStyles["optionssprint__arrow"]}
                ${isCollapsed ? detailProjectStyles["optionssprint__arrow--collapsed"] : ''}`}
              alt="arrow down Toggle section"
            />
          </button>
          <span className={detailProjectStyles["optionssprint__text"]}>{title}</span>
        </div>
        <div className={detailProjectStyles["optionssprint__addmenu"]}>
          <img src={addcircle} className={detailProjectStyles["optionssprint__add"]}
            alt="add task icon image"
            width={32} height={32}
            onClick={() => setTask(!task)}
          />
          <button className={detailProjectStyles["optionboard__button"]} aria-label='button section options'
            onClick={() => handleClick(sectionId)} style={{ marginLeft: '10px' }}
          >
            <img src={menupoints} alt="menu points" width={4} height={20} />
          </button>
          {
            activeId?.id === sectionId && activeId?.active === true && (
              <div className={detailProjectStyles["optionboard__options_crud"]}>
                {/* <button className={detailProjectStyles["optionboard__options_crud_delete"]}
                  onClick={() => handlerDelete(sectionId)}
                >
                  {t("module_projects.section_options_delete")}
                </button> */}
                <button className={detailProjectStyles["optionboard__options_crud_cancel"]}
                  onClick={() => handleCancel(0, false)}
                >
                  {t("module_projects.section_options_cancel")}
                </button>
                <button className={detailProjectStyles["optionboard__options_crud_cancel"]}
                  onClick={() => {
                    dispatch(showCreateUpdateSection({ id: sectionId, title, description }));
                    handleCancel(0, false);
                  }}
                >
                  {t("module_projects.section_options_update")}
                </button>
              </div>
            )
          }
        </div>
      </div>
      {task && <AddTask addNewTask={addNewTask} closeAddTask={closeAddTask} sectionId={sectionId.toString()} />}
    </div>
  )
}
